export const cloudUrl = 'https://ajeastorage.sqwiro.com';
